import { FC } from "react";
import ButtonPrimary from "../button.primary/button.primary.component";
import { Props } from "./form.interface";
import { Card, CardContent, CardHeader } from "./Status.styled";
import General from "../../stores/GeneralStore";

const StatusCard: FC<Props> = ({ onClick, refNum, status }: Props) => {
  return (
    <>
      <Card>
        <CardHeader>
          <h3>{General?.codeLabels["cm_forms_formstatus"]?.label !== undefined ? General?.codeLabels["cm_forms_formstatus"]?.label : "Form Statu"}s</h3>
        </CardHeader>
        <CardContent>
          <>
            <p>Request Reference Number</p>
            <span>
              <b>{refNum}</b>
            </span>
          </>
          <>
            <p>{General?.codeLabels["cm_pdc_status"]?.label !== undefined ? General?.codeLabels["cm_pdc_status"]?.label : "Status"}</p>
            <span>
              <b>{status}</b>
            </span>
          </>
          <ButtonPrimary onClick={onClick} label="Close" />
        </CardContent>
      </Card>
    </>
  );
};

export default StatusCard;
